import './main.scss';
import 'htmx.org';
import { Dropdown, Tab, Collapse, Popover, Modal, Tooltip } from 'bootstrap';
import AirDatepicker from 'air-datepicker';

import './helpers'
import './tempShit'
import './events'
import '../widgets/header/header'
import '../widgets/search/search'
import '../widgets/sets/sets'
import '../widgets/additional-sets/additionalSets'
import '../widgets/info-block/info-block'
import '../pages/checkout/checkout-form'
import '../pages/checkout/checkout-post-form'
import '../pages/login/login'
import '../pages/archive/archive'
import '../pages/publication/publication'
import '../pages/search/search-page'
import '../pages/tags/tags'
import '../pages/doc/doc'
import '../pages/cabinet/cabinet'
import '../pages/my-base/my-folders'
import '../pages/calculators/base'
import '../pages/calculators/salary-calculator'
import '../pages/calculators/esv-calculator'
import '../pages/calculators/sick-calculator'
import '../pages/calculators/maternity-calculator'
import '../pages/calculators/calculator-vacation'


import '../shared/ui/validation'
import '../shared/ui/asideControl'
import '../shared/ui/posts'
import '../shared/ui/inputs/textField/textField'
import '../shared/ui/inputs/select/select'
import '../shared/ui/toolbar/toolbar'
import '../shared/ui/pagination/pagination'
import '../shared/ui/toc/toc.js'
import '../widgets/widget-subscribe-category/widget-subscribe-category'
import '../widgets/widget-banner-cards/widget-banner-cards'
import '../widgets/widget-slider/widget-slider'
import '../widgets/widget-main-banner/widget-main-banner'

const sections = document.querySelectorAll('.js--section');

if (sections) {
  sections.forEach((item) => {
    item.style.setProperty('--set-bg-color', item.getAttribute('data-bg-color'));

    if (item.classList.contains('section--folder') || item.classList.contains('section--folder-left')) {
      const prevSection = item.previousElementSibling;

      if (prevSection && (prevSection.tagName.toLowerCase() === 'div' || prevSection.tagName.toLowerCase() === 'section')) {
        prevSection.classList.add('section--fix-padding');
      }
    }
  });
}

function isTouchSupported() {
    return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
}

if (!isTouchSupported()) {
  const tooltips = document.querySelectorAll('.js--tooltip');
  if (tooltips) {
    tooltips.forEach(tooltipEl => {
      const tooltip = new Tooltip(tooltipEl);
    });
  }
}

const dropdowns = document.querySelectorAll('.js--dropdown');
if (dropdowns) {
  dropdowns.forEach(dropdown => {
    dropdown.addEventListener('mouseenter', function (e) {
      document.body.style.position = 'fixed';
      document.body.style.paddingRight = '4px';
      document.body.style.width = '100%';
    });
    dropdown.addEventListener('mouseleave', function (e) {
      document.body.style.position = 'static';
      document.body.style.paddingRight = '0px';
      document.body.style.width = '100%';
    });
  });
}


function initCopyrightOnCopy() {
  function addLink() {
    var bodyElement = document.body;
    var selection = window.getSelection();
    var lng = bodyElement.classList.contains("ua") ? "ua" : "ru";
    var msg = lng === 'ru' ? 'Подробнее по ссылке' : 'Більш детально за посиланням';
    var pageLink = "<br /><br /> " + msg + ": <a href='" + document.location.href + "'>" + document.location.href + "</a>";
    var copyText = selection + pageLink;

    var newDiv = document.createElement('div');
    newDiv.style.position = 'absolute';
    newDiv.style.left = '-99999px';
    bodyElement.appendChild(newDiv);
    newDiv.innerHTML = copyText;

    selection.removeAllRanges();
    var range = document.createRange();
    range.selectNodeContents(newDiv);
    selection.addRange(range);

    setTimeout(function() {
      bodyElement.removeChild(newDiv);
    }, 0);
  }

  document.addEventListener('copy', addLink);
}
function initTables() {
  // document.querySelectorAll(".table table").forEach(function(table) {
  //   const tContainer = table.closest(".table");
  //   let scale = 0;
  //
  //   window.addEventListener("load", function() {
  //     table.setAttribute("data-width", table.offsetWidth);
  //     table.setAttribute("data-height", table.offsetHeight);
  //   });
  //
  //   if (document.querySelector("#page.print")) {
  //     document.querySelectorAll("#post-content .table").forEach(function(t) {
  //       if (t.querySelector("tr:last-child td") && t.querySelector("tr:last-child").children.length > 6) {
  //         t.querySelectorAll(".hidden").forEach(el => el.classList.remove("hidden"));
  //         t.querySelector(".btn-open-target").classList.add("hidden");
  //         t.querySelector("table").classList.add("hidden");
  //       }
  //     });
  //   } else {
  //     function scaleTable() {
  //       if (parseInt(tContainer.offsetWidth) < parseInt(table.getAttribute("data-width"))) {
  //         scale = parseInt(tContainer.offsetWidth) / parseInt(table.getAttribute("data-width"));
  //         table.style.transform = "scale(" + scale + ")";
  //         tContainer.style.height = parseInt(table.getAttribute("data-height")) * scale + "px";
  //         tContainer.classList.add("scaled");
  //       } else {
  //         table.style.transform = "scale(1)";
  //         tContainer.style.height = "auto";
  //         tContainer.classList.remove("scaled");
  //       }
  //     }
  //
  //     window.addEventListener("load", scaleTable);
  //     window.addEventListener("resize", scaleTable);
  //   }
  // });
  document.querySelectorAll(".table table").forEach(function (table) {
    if (table.offsetParent === null) return; // Проверяем, видим ли элемент

    var tContainer = table.closest(".table");
    var scale = 0;

    window.addEventListener("load", function () {
      table.setAttribute("data-width", table.querySelector('tbody').offsetWidth);
      table.setAttribute("data-height", table.querySelector('tbody').offsetHeight);
    });

    if (document.querySelector("#page.print")) {
      document.querySelectorAll("#post-content .table").forEach(function (tableWrapper) {
        var lastRow = tableWrapper.querySelector("tr:last-child");
        if (lastRow && lastRow.querySelectorAll("td").length > 6) {
          tableWrapper.querySelectorAll(".hidden").forEach(el => el.classList.remove("hidden"));
          tableWrapper.querySelectorAll(".btn-open-target").forEach(el => el.classList.add("hidden"));
          tableWrapper.querySelectorAll("table").forEach(el => el.classList.add("hidden"));
        }
      });
    } else {
      function resizeHandler() {
        var tableWidth = parseInt(table.getAttribute("data-width"));
        var tableHeight = parseInt(table.getAttribute("data-height"));
        var containerWidth = parseInt(tContainer.offsetWidth);

        if (containerWidth < tableWidth) {
          scale = containerWidth / tableWidth;

          // table.style.transformOrigin = "0 0";
          // table.style.transform = `scale(${scale})`;

          // table.style.transform = `scale(${scale})`;

          table.style.transformOrigin = "0 0";
          table.style.transform = `scale(${scale - 0.001})`;
          table.style.width = (100 / scale) + "%";

          // tContainer.style.height = "auto";
          // console.log(tableHeight);
          // console.log(scale);
          // console.log(tableHeight * scale);
          tContainer.style.height = (tableHeight * scale) + "px";
          tContainer.style.width = (100) + "%";
          tContainer.classList.add("scaled");
        } else {
          table.style.transformOrigin = "";
          table.style.transform = "scale(1)";
          table.style.width = "100%";
          tContainer.style.height = "auto";
          tContainer.classList.remove("scaled");
        }
      }

      window.addEventListener("load", resizeHandler);
      window.addEventListener("resize", resizeHandler);
      resizeHandler();
    }
  });
}
document.addEventListener("DOMContentLoaded", function() {
  initTables();
  initCopyrightOnCopy();
});

document.querySelectorAll('.datapicker').forEach(function(el) {
  new AirDatepicker(el, {
    dateFormat: 'dd.MM.yyyy',
    classes: 'custom_datapicker',
    autoClose: true,
    selectedDates: el.value ? [parseDate(el.value)] : [],
    onSelect({ date, formattedDate, datepicker }) {
      console.log(formattedDate);
      datepicker.$el.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
});
function parseDate(dateString) {
  const [day, month, year] = dateString.split('.');
  return new Date(`${year}-${month}-${day}`);
}


